module.exports = __webpack_public_path__ + "static/media/KaTeX_Size4-Regular.70174da7.ttf";